import { ADMIN_PASSWORD, AUTH_KEY } from './adminAuth';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function parseResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'API isteği başarısız oldu.');
  }
  return data;
}

export async function apiRequest(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (sessionStorage.getItem(AUTH_KEY) === 'true') {
    headers['X-Admin-Password'] = ADMIN_PASSWORD;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  return parseResponse(response);
}

export async function apiGet(path) {
  return apiRequest(path, { method: 'GET' });
}

export async function apiPost(path, body) {
  return apiRequest(path, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function apiPut(path, body) {
  return apiRequest(path, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export async function apiDelete(path) {
  return apiRequest(path, { method: 'DELETE' });
}
